import { render, staticRenderFns } from "./ModuleList.vue?vue&type=template&id=7ed9a66d&scoped=true&"
import script from "./ModuleList.vue?vue&type=script&lang=js&"
export * from "./ModuleList.vue?vue&type=script&lang=js&"
import style0 from "./ModuleList.vue?vue&type=style&index=0&id=7ed9a66d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed9a66d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemAction})
